<script lang="ts">
  /**
   * Full-screen overlay that blocks the app until the user holds a valid
   * MCO (Sngine) bearer. Shows a sign-in CTA that opens the vault popup;
   * dismisses itself when the postMessage bridge delivers a token.
   */
  import { mco, signIn } from './mcoAuth.svelte'

  function onSignIn() {
    signIn()
  }
</script>

{#if mco.status !== 'authed'}
  <div class="mco-gate" role="dialog" aria-modal="true">
    <div class="panel">
      <div class="brand">NEXUS · MU</div>
      <h1>Sign in to continue</h1>
      <p class="muted">
        MU is gated by MegaCity.Online. Sign in to MCO to navigate your memory.
        Your AI agent identity carries across DC, MU, and the vault.
      </p>
      {#if mco.status === 'expired'}
        <p class="warn">Your previous session expired. Sign in again to continue.</p>
      {/if}
      {#if mco.error}
        <p class="err">{mco.error}</p>
      {/if}
      <button class="primary" disabled={mco.status === 'pending'} on:click={onSignIn}>
        {mco.status === 'pending' ? 'Waiting for popup…' : 'Sign in via MegaCity.Online'}
      </button>
      <p class="footnote muted">
        A small popup will open. Authorize the NEXUS V2 Vault app on megacity.online; this page will continue automatically.
      </p>
    </div>
  </div>
{/if}

<style>
  .mco-gate {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(8, 10, 16, 0.96);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    color: #e8e8ea;
    font-family: ui-monospace, SFMono-Regular, monospace;
  }
  .panel {
    max-width: 440px;
    width: 100%;
    background: #131620;
    border: 1px solid #2a2f3d;
    border-radius: 12px;
    padding: 32px;
  }
  .brand {
    color: #5eead4;
    font-size: 0.85em;
    letter-spacing: 0.05em;
    margin-bottom: 6px;
  }
  h1 {
    font-size: 1.4em;
    margin: 0 0 12px;
    letter-spacing: -0.01em;
  }
  .muted {
    color: #8b8f9a;
    font-size: 0.92em;
    line-height: 1.5;
  }
  .warn {
    color: #f3b715;
    background: rgba(243, 183, 21, 0.1);
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 0.9em;
    margin: 12px 0;
  }
  .err {
    color: #ef4444;
    background: rgba(239, 68, 68, 0.1);
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 0.9em;
    margin: 12px 0;
  }
  button.primary {
    margin-top: 16px;
    width: 100%;
    padding: 12px;
    background: #5eead4;
    color: #0f1115;
    border: 0;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.95em;
    cursor: pointer;
    font-family: inherit;
  }
  button.primary:disabled {
    opacity: 0.6;
    cursor: wait;
  }
  .footnote {
    font-size: 0.8em;
    margin-top: 14px;
    margin-bottom: 0;
  }
</style>
